document.addEventListener("DOMContentLoaded", function () {
  new Splide(".announcement-slider", {
    drag: false,
    breakpoints: {
      767: {
        arrows: false,
      },
    },
  }).mount();

  new Splide(".proven-ingredients_slider", {
    type: "slide",
    type: "loop",
    perPage: 2,
    gap: 32,
    arrows: true,
    drag: true,
    padding: "13rem",
    breakpoints: {
      1023: {
        arrows: true,
        drag: true,
        perPage: 2,
        gap: 15,
        padding: "0",
      },
      767: {
        type: "slide",
        gap: 10,
        arrows: true,
        drag: true,
        perPage: 1,
      },
    },
  }).mount();

  new Splide(".wbg-testimonials-slider", {
    type: "loop",
    perPage: 3,
    gap: 20,
    arrows: true,
    breakpoints: {
      1023: {
        gap: 15,
        perPage: 2,
      },
      767: {
        arrows: false,
        gap: 10,
        perPage: 1,
      },
    },
  }).mount();

  const accordionTitles = document.querySelectorAll(".accordion-question");

  accordionTitles.forEach((title) => {
    const content = title.nextElementSibling;
    content.style.height = "0";
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease";

    title.addEventListener("click", function () {
      accordionTitles.forEach((otherTitle) => {
        if (otherTitle !== this) {
          otherTitle.classList.remove("open");
          const otherContent = otherTitle.nextElementSibling;
          otherContent.style.height = "0";
        }
      });

      this.classList.toggle("open");
      const btn = this.querySelector(".accordion-btn");
      const isOpen = this.classList.contains("open");

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0";
      }
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetID = this.getAttribute("href");
      const targetElement = document.querySelector(targetID);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop + 120, // Adjust for header if needed
          behavior: "smooth",
        });
      }
    });
  });

  const splideVideo = new Splide(".proven--video_slider", {
    type: "loop",
    perPage: 3,
    focus: "center",
    autoplay: true,
    interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    throttle: 300,
    breakpoints: {
      1440: {
        perPage: 1,
        padding: "30%",
      },
      767: {
        perPage: 1,
        padding: "25%",
      },
    },
  });

  splideVideo.on("move", () => {
    pauseAllVideos();
  });

  splideVideo.mount();

  // === Play/Pause functionality ===
  const playButtons = document.querySelectorAll(".proven-video__play");
  playButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.closest(".proven--video_slide").querySelector("video");
      const playIcon = this.getAttribute("data-icon-play");
      const pauseIcon = this.getAttribute("data-icon-pause");

      if (video.paused) {
        pauseAllVideos(video); // 🔁 Pause all other videos
        video.play();
        this.innerHTML = pauseIcon;
      } else {
        video.pause();
        this.innerHTML = playIcon;
      }
    });
  });

  function pauseAllVideos(except = null) {
    const videos = document.querySelectorAll(".proven--video_slide video");
    videos.forEach((vid) => {
      if (vid !== except && !vid.paused) {
        vid.pause();
        const playButton = vid
          .closest(".proven--video_slide")
          .querySelector(".proven-video__play");
        if (playButton) {
          const playIcon = playButton.getAttribute("data-icon-play");
          playButton.innerHTML = playIcon;
        }
      }
    });
  }

  // === Mute/Unmute functionality ===
  const muteButtons = document.querySelectorAll(".proven-video__mute");
  muteButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.closest(".proven--video_slide").querySelector("video");
      const muteIcon = this.getAttribute("data-icon-mute");
      const unmuteIcon = this.getAttribute("data-icon-unmute");

      video.muted = !video.muted;
      this.innerHTML = video.muted ? muteIcon : unmuteIcon;
    });
  });

  // === Fullscreen functionality ===
  const fullscreenButtons = document.querySelectorAll(
    ".proven-video__fullscreen"
  );

  fullscreenButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.closest(".proven--video_slide").querySelector("video");

      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
          // Safari
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          // IE11
          video.msRequestFullscreen();
        }
      }
    });
  });
});
